import { useEffect, useRef } from 'react';
import { useAuth } from '../lib/auth';
import { useTheme } from '../lib/theme';
import api from '../lib/api';

const DEFAULT_PREFS = { style: 'terminal', mode: 'dark' };

// Allinea la grafica all'account: carica le preferenze al login e le salva quando cambiano
export default function ThemePreferencesSync() {
    const { user } = useAuth();
    const { theme, uiStyle, applyPreferences } = useTheme();
    const loadedFor = useRef(null);
    const lastSaved = useRef(null);

    useEffect(() => {
        if (!user) {
            if (loadedFor.current) applyPreferences(DEFAULT_PREFS);
            loadedFor.current = null;
            return;
        }
        if (loadedFor.current === user.id) return;
        loadedFor.current = user.id;
        const saved = user.ui_preferences;
        const prefs = saved?.style && saved?.mode ? saved : DEFAULT_PREFS;
        lastSaved.current = `${prefs.style}|${prefs.mode}`;
        applyPreferences(prefs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.id]);

    useEffect(() => {
        if (!user || loadedFor.current !== user.id) return;
        const key = `${uiStyle}|${theme}`;
        if (lastSaved.current === key) return;
        const timer = setTimeout(() => {
            api.put('/auth/me/preferences', { style: uiStyle, mode: theme })
                .then(() => {
                    lastSaved.current = key;
                    try {
                        const saved = JSON.parse(localStorage.getItem('user') || '{}');
                        saved.ui_preferences = { style: uiStyle, mode: theme };
                        localStorage.setItem('user', JSON.stringify(saved));
                    } catch { /* ignore */ }
                })
                .catch(() => {});
        }, 400);
        return () => clearTimeout(timer);
    }, [uiStyle, theme, user]);

    return null;
}
